import {FC} from 'react';
import {View, StyleSheet} from '@react-pdf/renderer';
import Table from './Table';
import {IPDFPCleanUp} from '../../../models/pdfReport';

const styles = StyleSheet.create({
    categorySection: {
        marginTop: 12,
    },
});

interface IProps {
    data: IPDFPCleanUp;
}

const LocationCollectedCategories: FC<IProps> = ({
    data: {
        collectedCategories,
    },
}) => {
    const nonZeroCategories = collectedCategories
        .map((category) => ({
            ...category,
            items: category.items.filter((item) => item.amount > 0),
        }))
        .filter((category) => category.items.length > 0);

    if (nonZeroCategories.length === 0) return null;

    return (
        <View style={{marginTop: 24}}>
            <Table
                title="COLLECTED ITEMS BY CATEGORY"
                titleInfo={`${nonZeroCategories.length} categories`}
                mode="grid"
                rows={[]}
            />

            {nonZeroCategories.map((category) => (
                <View key={category.id} style={styles.categorySection}>
                    <Table
                        title={category.name.toUpperCase()}
                        titleInfo={`${category.items.reduce((sum, item) => sum + item.amount, 0)} items`}
                        mode="grid"
                        rows={category.items.map((item) => ({
                            title: item.name,
                            info: `${item.amount}`,
                        }))}
                    />
                </View>
            ))}
        </View>
    );
};

export default LocationCollectedCategories;